import { render, staticRenderFns } from "./FamilyGrid.vue?vue&type=template&id=1e4860b9"
import script from "./FamilyGrid.vue?vue&type=script&lang=js"
export * from "./FamilyGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports